var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roleTemplateManager" } }, [
    _c(
      "div",
      { staticClass: "dialog-content" },
      [
        _vm.editing
          ? _c("div", { staticClass: "context" }, [
              _vm._v(
                "To edit a role template, select the title field and select or deselect the specific role permissions below."
              )
            ])
          : _c("div", { staticClass: "context" }, [
              _vm._v(
                "To add a new role template, enter a title, select an access level, and select which permissions this role template will allow."
              )
            ]),
        _vm._v(" "),
        _c(
          "v-form",
          [
            _c("v-text-field", {
              ref: "inputTitle",
              attrs: {
                "validate-on-blur":
                  _vm.$refs.inputTitle && _vm.$refs.inputTitle.valid,
                rules: _vm.rules.title,
                label: "Title",
                "prepend-icon": "mdi-format-title",
                disabled: _vm.editing
              },
              model: {
                value: _vm.role.title,
                callback: function($$v) {
                  _vm.$set(
                    _vm.role,
                    "title",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "role.title"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "title-area", staticStyle: { "margin-top": "16px" } },
          [_vm._v("Permissions")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "div",
              {
                staticClass: "subtitle",
                staticStyle: { "margin-bottom": "16px" }
              },
              [_vm._v("Access Level")]
            ),
            _vm._v(" "),
            _vm.editing
              ? _c(
                  "div",
                  {
                    staticClass: "context",
                    staticStyle: { "margin-bottom": "0" }
                  },
                  [
                    _vm._v(
                      "Access levels define how much access a user has on your company. Access levels cannot be modified once a role template has been created."
                    )
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "context",
                    staticStyle: { "margin-bottom": "0px" }
                  },
                  [
                    _vm._v(
                      "Access levels define how much access a user has on your company. Access levels cannot be modified once a role template has been created.\n        "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n        Unit Specific: Permissions only allow access within the unit they are assigned to.\n        "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n        Property Specific: Permissions only allow access for the items within the property they are assigned to.\n        "
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n        All Properties: Permissions apply to all properties.\n      "
                    )
                  ]
                ),
            _vm._v(" "),
            _c("v-select", {
              ref: "selectAccessLevel",
              attrs: {
                items: _vm.accessLevels,
                rules: _vm.rules.accessLevel,
                label: "Select an Access Level",
                disabled: _vm.editing,
                "single-line": "",
                bottom: ""
              },
              model: {
                value: _vm.role.accessLevel,
                callback: function($$v) {
                  _vm.$set(_vm.role, "accessLevel", $$v)
                },
                expression: "role.accessLevel"
              }
            }),
            _vm._v(" "),
            _c("vo-role-permissions", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.role.accessLevel,
                  expression: "role.accessLevel"
                }
              ],
              ref: "rolePermissions",
              staticClass: "role-permissions",
              attrs: { accessLevel: _vm.role.accessLevel }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { disabled: _vm.lockout.on, flat: "", color: "info" },
            on: {
              click: function($event) {
                _vm.routeRemoveQueries(["dialog", "dialogAction"])
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout.on, flat: "", color: "primary" },
            on: {
              click: function($event) {
                _vm.editing ? _vm.save() : _vm.create()
              }
            }
          },
          [_vm._v(_vm._s(_vm.editing ? "Save" : "Create"))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-223e8845", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223e8845","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoleTemplateManage.vue
// module id = 566
// module chunks = 4